import React from 'react';

const surfaceCardStyles = {
  background: '#fff',
  border: '1px solid #e7ebf0',
  borderRadius: 8,
};

export const categoryNavStyles = (theme) => ({
  sidebarMenu: {
    ...surfaceCardStyles,
    padding: theme.spacing(1.75, 1.25, 1.25),
    [theme.breakpoints.up('md')]: {
      position: 'sticky',
      top: theme.spacing(2),
      maxHeight: 'calc(100vh - 120px)',
      overflow: 'auto',
      alignSelf: 'flex-start',
    },
  },
  sidebarTitle: {
    margin: theme.spacing(0, 0.75, 1.25),
    fontSize: '0.75rem',
    fontWeight: 700,
    color: '#647184',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
  },
  categoryList: {
    padding: 0,
    '& .MuiMenuItem-root': {
      margin: '0 0 4px',
    },
    '& .MuiMenuItem-root:last-child': {
      marginBottom: 0,
    },
  },
  categoryItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minHeight: 40,
    padding: '8px 10px',
    borderRadius: 10,
    color: '#263548',
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.35,
    whiteSpace: 'normal',
    transition: 'background-color 0.15s ease, color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(61, 125, 221, 0.08)',
    },
  },
  subcategoryItem: {
    minHeight: 34,
    marginLeft: 12,
    paddingLeft: 12,
    fontSize: '0.8125rem !important',
    fontWeight: '500 !important',
    color: '#647184 !important',
    borderLeft: '2px solid #e7ebf0',
    borderRadius: '0 10px 10px 0',
    '& $countChip': {
      minWidth: 18,
      height: 18,
      padding: '0 5px',
      backgroundColor: 'transparent',
      border: '1px solid #d5dde8',
      color: '#94a3b8',
      fontSize: 10,
      fontWeight: 600,
    },
    '&$categoryItemActive $countChip': {
      backgroundColor: 'transparent',
      borderColor: 'rgba(255,255,255,0.9)',
      color: '#fff',
    },
  },
  categoryItemActive: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: '#fff !important',
    borderColor: 'transparent',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main} !important`,
    },
  },
  categoryLabel: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  countChip: {
    flex: '0 0 auto',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 24,
    height: 22,
    padding: '0 7px',
    borderRadius: 999,
    backgroundColor: '#e7eef8',
    color: '#3d5270',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1,
    boxSizing: 'border-box',
  },
  countChipActive: {
    backgroundColor: 'rgba(255,255,255,0.95)',
    color: theme.palette.primary.main,
  },
});

export const CategoryCount = ({ count, active, classes }) => {
  if (count == null || count === '') {
    return null;
  }
  const value = Number(count);
  const label = Number.isFinite(value) && value > 9999 ? '9999+' : count;
  return (
    <span className={`${classes.countChip}${active ? ` ${classes.countChipActive}` : ''}`}>
      {label}
    </span>
  );
};
